export default "__VITE_ASSET__b953c460__"